import { useState } from "react";
import { LockKeyhole, Loader2 } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
export const AdminLogin = ({ login }) => {
  const { t } = useLanguage();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async event => {
    event.preventDefault(); setBusy(true); setError("");
    try { await login(email, password); setPassword(""); }
    catch (error) { setError(error.response?.status === 429 ? "Too many attempts. Please wait 15 minutes." : "Sign-in failed. Please check your credentials and try again."); }
    finally { setBusy(false); }
  };
  return <form data-testid="admin-login-form" onSubmit={submit} className="mt-10 max-w-md space-y-5">
    <div><label htmlFor="admin-email" className="studio-label">{t("Email")}</label><input data-testid="admin-email-input" id="admin-email" type="email" autoComplete="username" className="studio-input" value={email} onChange={event => setEmail(event.target.value)} required /></div>
    <div><label htmlFor="admin-password" className="studio-label">{t("Password")}</label><input data-testid="admin-password-input" id="admin-password" type="password" autoComplete="current-password" className="studio-input" value={password} onChange={event => setPassword(event.target.value)} required /></div>
    {error && <p data-testid="admin-login-error" role="alert" className="text-sm text-rose-300">{t(error)}</p>}
    <button data-testid="admin-login-submit" type="submit" disabled={busy} className="btn-primary">{busy ? <Loader2 size={16} className="animate-spin" /> : <LockKeyhole size={16} />}{t("Sign in")}</button>
  </form>;
};